import { render, staticRenderFns } from "./PageCreate.vue?vue&type=template&id=f1cf66ca&scoped=true&"
import script from "./PageCreate.vue?vue&type=script&lang=js&"
export * from "./PageCreate.vue?vue&type=script&lang=js&"
import style0 from "./PageCreate.vue?vue&type=style&index=0&id=f1cf66ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1cf66ca",
  null
  
)

export default component.exports